module.exports = __webpack_public_path__ + "static/media/icon2.a3144774.png";